import { render, staticRenderFns } from "./ConsultPhone.vue?vue&type=template&id=233e13f8&scoped=true&"
import script from "./ConsultPhone.vue?vue&type=script&lang=js&"
export * from "./ConsultPhone.vue?vue&type=script&lang=js&"
import style0 from "./ConsultPhone.vue?vue&type=style&index=0&id=233e13f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233e13f8",
  null
  
)

export default component.exports